import { render, staticRenderFns } from "./ContratacaoDesfazerCancelamentoDespViagem.vue?vue&type=template&id=72f0978b"
import script from "./ContratacaoDesfazerCancelamentoDespViagem.vue?vue&type=script&lang=js"
export * from "./ContratacaoDesfazerCancelamentoDespViagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports